export default {
  dialogTitle: {
    notes: 'Title of the add to shopping list dialog',
    message: 'Add to shopping list',
  },
};
